module.exports = __webpack_public_path__ + "img/onedegree.1a0a0de.svg";